import { mutate } from "swr";
import { setIsLoading } from "../store";
import { fetchGlobal } from "../../../../../api/hooks";

export async function editPayment(franchiseID: any, updatedRows: any, setIsAddPaymentClicked: Function,
    setDataIsUpdated: Function, dataIsUpdated: boolean | number) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["paymentMethod"],
            data: updatedRows,
        }),
    };
    try {
        const data = await fetchGlobal<any>(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        } else {
            setDataIsUpdated(!dataIsUpdated);
            setIsAddPaymentClicked(false);
        }
        setIsLoading(false);

        mutate(apiUrl, data);
    } catch (e) {
        setIsLoading(false);
    }
};